<div class="keyword-management-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ ('BUTTON.' + data.mode | translate) + ' ' + (data.type + '.TITLE' | translate) }}</span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		@if (data.mode === 'NEW' || data.mode === 'EDIT') {
		<form [formGroup]="formGroup" class="pe-2 pt-2">
			@if (data.mode === 'NEW') {
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.TITLE' | translate }}</mat-label>
					<mat-chip-grid #chipGrid>
						@for (text of texts; track text) {
						<mat-chip-row (removed)="removeText(text)">
							{{ text }}
							<button matChipRemove>
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-chip-row>
						}
					</mat-chip-grid>
					<input
						matInput
						cdkFocusInitial
						[matChipInputFor]="chipGrid"
						[matChipInputSeparatorKeyCodes]="separatorKeyCodes"
						(matChipInputTokenEnd)="addText($event)"
						(blur)="addTextFromInputOnBlur($event)" />
				</mat-form-field>
			</div>
			} @else {
			<div class="row">
				<mat-form-field class="pb-3">
					<mat-label>{{ data.type + '.TITLE' | translate }}</mat-label>
					<input matInput type="text" formControlName="text" cdkFocusInitial />
				</mat-form-field>
			</div>
			}

			<div class="row">
				<mat-label>{{ data.type + '.SELECT_SOURCE' | translate }}</mat-label>
				<div class="d-flex flex-column">
					@for (source of keywordSources; track source) {
					<mat-checkbox [checked]="selectedSources.includes(source)" [disabled]="isSourceDisabled(source)" (change)="manageSources($event, source)">{{ source }}</mat-checkbox>
					}
				</div>
			</div>

			<!-- TAGS selection -->
			<div class="row px-1">
				<mat-accordion #tagsAccordion="matAccordion" multi>
					@for (category of tagCategories; track $index ) {
					<mat-expansion-panel [expanded]="category.isOpened" (click)="getTagsForCategory(category)">
						<mat-expansion-panel-header>
							<mat-panel-title>
								<span>
									{{ utils.getParameterByName(category, 'value') }}
								</span>
							</mat-panel-title>
							<mat-panel-description> </mat-panel-description>
						</mat-expansion-panel-header>

						<div class="d-flex flex-row flex-wrap p-2">
							<span class="list-section w-100">
								<ul class="p-0 m-0">
									@for (tag of utils.getParameterByName(category, 'tags'); track tag.id) {
									<li class="d-flex align-items-start justify-content-between">
										<mat-checkbox (change)="manageTags($event, tag)" [checked]="tag.checked">
											<div class="d-flex">
												<div class="tag-item" [style.background-color]="tag.colorCode"></div>
												<span>{{ tag.value }}</span>
											</div>
										</mat-checkbox>
									</li>
									}
								</ul>
							</span>
						</div>
					</mat-expansion-panel>
					}
				</mat-accordion>
			</div>
			<!-- (END)TAGS selection -->
		</form>

		} @else if (data.mode === 'DELETE') {
		<span> {{ 'ASSORTED.DELETE_CONFIRMATION_MESSAGE' | translate }} {{ data.item.text }}? </span>
		}
	</mat-dialog-content>
	<mat-dialog-actions [align]="'end'">
		<mat-divider class="w-100 my-2"></mat-divider>
		@if (data.mode === 'DELETE') {
		<div class="d-flex justify-content-end pt-0">
			<button mat-flat-button color="warn" (click)="action()">
				{{ 'ASSORTED.YES' | translate }}
			</button>
			<button mat-flat-button color="primary" (click)="closeDialog()">
				{{ 'ASSORTED.NO' | translate }}
			</button>
		</div>
		} @else {
		<div class="d-flex pt-0 me-3">
      <button mat-flat-button color="primary" (click)="action()" [disabled]="formGroup.invalid || apiLoading.management">
				<div class="d-flex">
					@if(apiLoading.management) {
					<mat-spinner diameter="15" class="me-1"></mat-spinner>
					}
					<span>{{ 'BUTTON.SAVE' | translate }}</span>
				</div>
			</button>
		</div>
		}
	</mat-dialog-actions>
</div>
